<template>
    <div>
      <!-- <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" /> -->
      <div id="app">
        <div class="list-box ">
          <div class="title">CASHE DETAILS</div>
          <div class="flex flex-align-center flex-justify-between">
            <div class="font-16 left-text">AMOUNT TO REPAY</div>
            <div class="font-15" style="color: red;">Rs. {{ form.amount }}</div>
          </div>
          <div class="flex flex-align-center flex-justify-between  margin-top-24">
            <div class="font-16  left-text">PRODUCT NAME</div>
            <div class="font-15">{{ form.name }}</div>
          </div>
  
        </div>
        <div class="fixed repay-box">
          <div class="theme-back repay" @click="payThirdOrder()">
            Repay Now
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {}
      }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id;
            this.getThirdOrderInfo();
        }
    },
    methods: {
        getThirdOrderInfo() {
            this.$http.post('/api/product/thirdOrderInfo', { id: this.form.id }).then((res) => {
                console.log(res.data.code)
                if (res.data.code == 0) {
                    this.form = res.data.data;
                } else {
                    this.$toast(res.data.msg)
                }
            })
        },
        payThirdOrder() {
            this.$http.post('/api/product/payThirdOrder', { orderId: this.form.id }).then((res) => {
                if (res.data.code == 0) {
                    window.location.href = res.data.data.url
                } else {
                    this.$toast(res.data.msg)
                }
            })
        },
    
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less" scoped>
  #app {
    background: #F9F9F9;
    min-height: 100vh;
    padding: 12px 12px 0px 12px;
    box-sizing: border-box;
  
    .title {
      font-size: 15px;
      color: #FFA06A;
      font-weight: 500;
      margin-bottom: 20px;
    }
  
    .list-box {
      background: #FFFFFF;
      padding: 14px;
      border-radius: 14px;
  
      .left-text {
        color: #666666;
      }
    }
  
    .repay-box {
      bottom: 10px;
      margin: 0 38px;
      left: 0;
      right: 0;
      text-align: center;
      box-sizing: border-box;
  
      .rollover {
        height: 22px;
        font-size: 16px;
        color: #FF5D00;
        line-height: 22px;
        margin-bottom: 10px;
      }
  
      .repay {
        padding: 12px 0px;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
        border-radius: 24px;
      }
  
      .repay_between {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
      }
    }
  
  }
  </style>
  